import Ladda from 'ladda';
import humane from 'humane-js/humane';
import { checkStatus, parseJSON } from './HttpRequest';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';

humane.error = humane.spawn({addnCls: 'humane-flatty-error', timeout: 2500});

// Load all quantities from basket-items
const getAllBasketItems = () => {
	if (document.getElementById('get-all-basket-items')) {
		let uri = document.getElementById('get-all-basket-items').getAttribute('data-uri');
		window.fetch(uri, {
			//cache: 'no-cache',
			credentials: 'same-origin'
		})
			.then(checkStatus)
			.then(parseJSON)
			.then(result => {
				for (let key in result.items) {
					if (!result.items.hasOwnProperty(key)) continue;

					let productNode = document.getElementById('product-' + key);
					if (productNode) {
						productNode.querySelector('input[name="quantity"]').value = result.items[key]['quantity'];
					}
				}
			})
			.catch(ex => {
				console.error('parsing failed in function getAllBasketItems', ex);
			})
	}
};
getAllBasketItems();

// add / update / remove products to basket
const updateBasketItem = (item, total) => {
	$(item).find('.basket-list-total-int').text(total.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1\''));
};

let overviewBasketLink = document.querySelector('.basket-link .btn');
if (overviewBasketLink) {
	overviewBasketLink.addEventListener('click', (e) => {

		if (!e.target.dataset.minorder) {
			let documentMinOrderCostElem = document.querySelector('div.basket-total');
			if (documentMinOrderCostElem.dataset.minordercost) {
				e.target.dataset.minorder = documentMinOrderCostElem.dataset.minordercost;
			}
		}

		if (e.target.dataset.minorder && e.target.dataset.minorder > 0 && e.target.dataset.minordertext) {
			if (!confirm(e.target.dataset.minordertext.replace('%s', e.target.dataset.minorder.toString()))) {
				e.preventDefault();
				return false;
			}
		}

		return true;
	});
}

const updateMinOrderCost = (minOrderCostActive, minOrderCost) => {
	let basketMinOrderCost = document.getElementById('basket-list__min-order-cost');
	if (basketMinOrderCost) {
		if (minOrderCostActive === true) {
			$(basketMinOrderCost).show();
		} else {
			$(basketMinOrderCost).hide();
		}
	}

	if (minOrderCost) {
		let minOrderCostElem = document.getElementById('min-order-cost');
		if (minOrderCostElem) {
			minOrderCostElem.innerHTML = minOrderCost;
		}
	}

	if (overviewBasketLink) {
		overviewBasketLink.dataset.minorder = minOrderCost;
	}

	let overviewOrderCostInfo = document.querySelector('.basket-total-total-cost-info');
	if (overviewOrderCostInfo) {
		if (minOrderCost > 0) {
			overviewOrderCostInfo.style.display = '';
		} else {
			overviewOrderCostInfo.style.display = 'none';
		}
	}
};

const updateCateringBasketToal = (total) => {
	let basketTotal = document.getElementById('basket-total');
	$(basketTotal).text(total);
	$(basketTotal).attr('title', total);

	if (parseFloat(total) > 0) {
		$(basketTotal).parent().removeClass('basket-total-hidden');
	} else {
		$(basketTotal).parent().addClass('basket-total-hidden');
	}
};

const removeBasketItem = (item) => {
	if (item.parentNode.querySelectorAll('tr').length <= 1) {
		$('.basket-container').addClass('basket-empty-hidden');
		$('#basket-empty-message').removeClass('basket-empty-hidden');
	} else {
		item.parentNode.removeChild(item);
	}
};

$('.basket-ajax-update').each((index, form) => {
	let button = form.querySelector('.btn-catering-add');
	let quantityInputField = form.querySelector('.quantity');
	let uri = $(form).attr('action');
	let basketItem = $(form).hasClass('is-basket');
	let basketSpinner = $(form).hasClass('is-basket-spinner');

	if (basketItem) {
		basketItem = $(form).closest('tr').get(0);
	}

	const handleSubmit = () => {
		let btnLoading = null;

		if (quantityInputField && quantityInputField.value === '') {
			return false;
		}
		if (button) {
			btnLoading = Ladda.create(button);
			btnLoading.start();
		}

		let data = new FormData(form);
		if (!basketItem) {
			data.append('__csrfToken', csrfToken);
		}

		window.fetch(uri, {
			method: 'POST',
			credentials: 'same-origin',
			body: data
		})
			.then(checkStatus)
			.then(response => {
				return response.json();
			})
			.then(result => {
				if (result.status === 'success') {
					humane.log(result.message);

					if (basketItem) {
						if (result.action === 'remove') {
							removeBasketItem(basketItem);
						} else {
							updateBasketItem(basketItem, result.item.total);
						}
						updateMinOrderCost(result.total.minOrderCostActive, result.total.minOrderCostFormated);
						updateCateringBasketToal(result.total.total);
					} else {
						// empty "0" in inputfield
						if (quantityInputField) {
							if (quantityInputField.value <= 0) {
								quantityInputField.value = '';
							}
						}
						updateMinOrderCost(result.total.minOrderCostActive, result.total.minOrderCostFormated);
						updateCateringBasketToal(result.total.subtotal);
					}
				} else {
					humane.error(result.message);

					if (quantityInputField) {
						quantityInputField.value = '';
					}
					getAllBasketItems();
				}

				if (button) {
					button.blur();
					btnLoading.stop();
				}
			})
			.catch(error => {
				console.error('error in submit basket-ajax-update', error);
			});
	};

	$(form).on('submit', event => {
		event.preventDefault();
		if (!basketSpinner) {
			handleSubmit();
		}
	});

	$(form).on('spinupdate', handleSubmit);

});

// Loading and disable form submit
$(".basket-content-container a.btn.loading").on("click", event => {
	$(event.target).closest(".btn.loading").addClass("running");
});
